import StoreRegisterContainer from './StoreRegisterContainer';
export default StoreRegisterContainer;
